<template>
  <div>
    <lk-card title="处方信息">
      <div ref="prescriptionPart">
        <lk-form ref="prescription" :label-width="90" :rules='salePrescription' :model='info'>
           <lk-row :gutter='16' v-if='able'>
               <lk-col span='7'>
                 <lk-form-item label="患者检索:">

                   <prescriptionSearch @selected='importPresription' :type='3'></prescriptionSearch>
                 </lk-form-item>
               </lk-col>
             </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label="处方时间:" prop="prescriptionTime">
                <timeStampDatePicker style="width:100%" ref="prescription4" placeholder='请选择' v-if="able"
                  v-model="info.prescriptionTime "></timeStampDatePicker>
                  <span v-else>{{info.prescriptionTime |formatDate}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="处方医院:" prop="prescriptionHospital">
                <prescriptionHospital :maxlength='100' ref="prescription1" placeholder='请输入' v-if='able'
                  v-model="info.prescriptionHospital "></prescriptionHospital>
                  <span v-else>{{info.prescriptionHospital }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="科室:" prop="hospitalDept">
                <lk-input :maxlength='20' ref="prescription5" placeholder='请输入' v-if='able'
                  v-model="info.hospitalDept "></lk-input>
                  <span v-else>{{info.hospitalDept }}</span>
              </lk-form-item>
            </lk-col>

          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label="医生:" prop="prescriptionDoctor">
                <lk-input :maxlength='30' ref="prescription2" placeholder='请输入' v-if='able'
                  v-model="info.prescriptionDoctor ">
                </lk-input>
                  <span v-else>{{info.prescriptionDoctor }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="患者姓名:" prop="patientName">
                <lk-input :maxlength='30' placeholder='请输入' v-if='able' v-model="info.patientName ">
                </lk-input>
                  <span v-else>{{info.patientName }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="患者年龄:" prop="patientAge">
                <lk-input v-if='able' style='width:100%' :maxlength='4' number placeholder='请输入' v-model="info.patientAge "
                  ></lk-input>
                  <span v-else>{{info.patientAge }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label="患者联系方式:" prop="patientPhone">
                <lk-input v-if='able' :maxlength='30' placeholder='请输入' v-model="info.patientPhone ">
                </lk-input>
                  <span v-else>{{info.patientPhone }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="患者性别:" prop="patientGender">
                <lk-radio-group v-if='able' ref="prescription9" v-model="info.patientGender">
                  <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">

                    <span>{{item}}</span>
                  </lk-radio>

                </lk-radio-group>
                  <span v-else>{{genderList[info.patientGender] }}</span>

              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="临床诊断:" prop="diseaseId">

                <lk-select v-if='able' ref="prescription3" filterable v-model="info.diseaseId"
                @on-change='setAdditionalRemark'>
                  <lk-option v-for="(item,index) in diseaseList" :key="index" :value='item.id'>{{item.diseaseName}}</lk-option>

                </lk-select>
                  <span v-else>{{info.diseaseName }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label="诊断补充说明:" prop="additionalRemark"    :class="{'ivu-form-item-required':info.diseaseName==='其他'}">
                <lk-input v-if='able' :maxlength='100' ref="prescription11" placeholder='请输入'
                  v-model="info.additionalRemark "></lk-input>
                  <span v-else>{{info.additionalRemark }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="剂数:" prop="num">
                <lk-input-number :disabled='!numEditable' v-if='able' :maxlength='4' ref="prescription10" type='int' style='width:100%'
                  placeholder='请输入，大于零的正整数' :min="1" v-model="info.num "  :precision='0' :active-change='false'></lk-input-number>
                  <span v-else>{{info.num }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="煎，服法:" prop="goodsUsage">
                <lk-input :maxlength='30' ref="prescription6" placeholder='请输入' v-if="able"
                  v-model="info.goodsUsage "></lk-input>
                  <span v-else>{{info.goodsUsage }}</span>
              </lk-form-item>
            </lk-col>

          </lk-row>

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label="复核人:" prop="reviewer">
                <lk-select v-if='able' :ref='"prescription-1"' v-model="info.reviewer " placeholder='请输入'
                  filterable>

                  <lk-option v-for="item in pharmacistList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
                </lk-select>
                  <span v-else>{{info.reviewerName }}</span>

              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label="调配人:" prop="allocater">
                <lk-select v-if='able' :ref='"prescription-2"' placeholder='请输入' v-model="info.allocater "
                  filterable>
                  <lk-option v-for="item in pharmacistList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
                </lk-select>
                  <span v-else>{{info.allocaterName }}</span>
              </lk-form-item>
            </lk-col>
<lk-col span='7' offset='1'>
              <lk-form-item label="联系人:" prop="contact">
                <lk-input v-if='able' :maxlength='100'  placeholder='请输入'
                  v-model="info.contact"></lk-input>
                <span v-else>{{info.contact}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
    </lk-card>
  </div>
</template>
<script>
import utils from '../../libs/utils.js';
import timeStampDatePicker from '../timeStampDatePicker.vue';
import prescriptionSearch from './PatientSearch.vue';

import prescriptionHospital from './PrescriptionHospital.vue';

export default {
  name: 'prescriptionDrug',
  components: {

    timeStampDatePicker, prescriptionSearch, prescriptionHospital,
  },
  props: {
    // isDataLinkRx: {
    //   type: Boolean,
    //   default: false,
    // },
    data: {
      type: Object,

    },
    genderList: {
      type: Object,
      default: () => ({ 1: '男', 2: '女' }),
    },
    pharmacistList: {
      type: Array,

    },
    saleUsageList: {
      type: Array,

    },
    numEditable: {// 剂数是否可编辑
      type: Boolean,
      default: false,
    },
    diseaseList: { type: Array, default: () => [] },
    able: {},
  },
  model: {
    prop: 'data',
    event: 'change',
  },
  watch: {
    saleUsageList: {
      handler(val) {
        // val.forEach((item, index) => {
        //   this.info.saleUsageList[index] = Object.assign(this.info.saleUsageList[index], item);
        // });
        this.info.saleUsageList = val;
      },
      deep: true,
    },
    data: {
      handler() {
        this.info = this.data;
      },
      deep: true,
    },
    info: {
      handler() {
        this.$emit('change', this.info);
      },
      deep: true,
    },
  },
  data() {
    return {
      isValidated: false,
      info: {
        saleUsageList: [],
      },
      salePrescription: {
        prescriptionTime: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', type: 'date',
        }],
        prescriptionHospital: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
        hospitalDept: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
        prescriptionDoctor: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
        patientAge: [
          {
            required: true, message: '请输入正确的患者年龄', trigger: 'blur', type: 'integer', min: 0,
          },
        ],
        patientName: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
        patientPhone: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' },
          {
            validator: utils.validate.phoneValidator, message: '请输入正确联系方式', trigger: 'blur',
          }],
        patientGender: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', type: 'number',
        }],
        diseaseId: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', type: 'number',
        }],
        num: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', type: 'number',
        }],
        // number: [{
        //   required: true, message: '此处为必填项，不能为空。', trigger: 'blur', type: 'number',
        // }],
        goodsUsage: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur',
        }],
        allocater: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
        }],
        reviewer: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
        }],
      },
    };
  },
  methods: {
    setAdditionalRemark() {
      // console.log(this.info.diseaseId === 1);
      // this.isOther = this.info.diseaseId === 1;
      this.info.diseaseName = this.info.diseaseId ? this.diseaseList.find(item => item.id === this.info.diseaseId).diseaseName : '';
      console.log(this.info.diseaseName);
      if (this.info.diseaseName === '其他') {
        this.salePrescription.additionalRemark = [{ required: true, message: '请输入诊断补充说明', trigger: 'blur' }];
      } else {
        this.salePrescription.additionalRemark = [{ required: false }];
        this.$nextTick(() => {
          this.$refs.prescription.validateField('additionalRemark', () => {});
        });
      }
    },
    importPresription(data) {
      console.log(data);
      // Object.assign(this.info, data.salePrescription);
      data.salePrescription.id = this.info.id;
      data.salePrescription.num = this.info.num;
      this.info = utils.deepClone(data.salePrescription);
      this.isValidated && this.$nextTick(() => {
        this.validateForm();
      });
      // this.info = data.salePrescription;
    },
    exchangePharmacistList(val, key) {
      console.log(val);
      this.pharmacistList.forEach((item) => {
        if (item.id === val) {
          this.info[key] = item.name;
        }
      });
    },
    validateForm() {
      this.info.allocater = utils.isMatchFilter(this.pharmacistList, this.info.allocater);
      this.info.reviewer = utils.isMatchFilter(this.pharmacistList, this.info.reviewer);
      return new Promise((resolve) => {
        // let result = false;
        this.$refs.prescription.validate((valid) => {
        // result = valid;
          resolve(valid);
        });
        this.isValidated = true;
      });
    },
  },
  // created() {
  //   this.info.saleUsageList = this.saleUsageList;

  mounted() {
    this.info = this.data;
    this.info.saleUsageList = this.saleUsageList;
    this.isValidated = false;
    this.setAdditionalRemark();
  },
};
</script>
